<div class="d-flex vh-100 vw-100 d-flex align-items-center justify-content-center p-4">

  <div class="w-100 shadow p-5 loginFormMain" style="max-width: 400px;" *ngIf="disablePaswordSendLink">
    <div class="h5 text-center" style="color: #008A70;">Password Reset</div>
    <div class="card-body">
      <p class="text-muted py-2" *ngIf="isVisible">
        Enter your email address and we'll send you an email with instructions to reset your password.
      </p>
      <div class="alert alert-info" *ngIf="idNotFound">
        Please enter correct Email which was used during account creation.
      </div>
      <div data-mdb-input-init class="form-outline">
        <input type="email" [(ngModel)]="DigitalUserResetPwdDetail.email_id" class="customInputFields my-3"
          placeholder="Email" />
      </div>
      <div class="d-flex flex-column justify-content-center align-items-center w-100 gap-3">
        <button (click)="sendToken()" class="customPreActivatedButtons text-nowrap">Reset Now</button>
        <a class="btn btn-md rounded-pill text-success" href="/login">Login</a>
        <!-- <a class="" href="/sign-up">Register</a> -->
      </div>
    </div>
  </div>

  <form [formGroup]="resetForm" (ngSubmit)="onPasswordReset()">
    <!-- <div class="card text-center" style="width: 300px;" *ngIf="enablePasswordRest"> -->
      <div class="w-100 shadow p-5 loginFormMain" style="max-width: 400px;" *ngIf="enablePasswordRest" >
      <div class="h5 text-center" style="color: #008A70;">Password Reset</div>
      <div class="form-group">
        <label class="text-muted py-2" >Confirm Token</label>
        <input type="text" formControlName="generatedToken" class="customInputFields"
          [ngClass]="{ 'is-invalid': submitted && f['generatedToken'].errors }" />
        <div class="form-group">
          <label class="text-muted py-2" >Password</label>
          <input type="password" formControlName="pwd" class="customInputFields"
            [ngClass]="{ 'is-invalid': submitted && f['pwd'].errors }" />
          @if (submitted && f['pwd'].errors) {
          <div class="invalid-feedback">
            @if (f['pwd'].errors['required']) {
            <div>Password is required</div>
            } @if (f['pwd'].errors['minlength']) {
            <div>Password must be at least 6 characters</div>
            } @if (f['pwd'].errors['maxlength']) {
            <div>Username must not exceed 40 characters</div>
            }
          </div>
          }
        </div>

        <div class="form-group">
          <label class="text-muted py-2" >Confirm Password</label>
          <input type="password" formControlName="confirmPassword" class="customInputFields"
            [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }" />
          @if (submitted && f['confirmPassword'].errors) {
          <div class="invalid-feedback">
            @if (f['confirmPassword'].errors['required']) {
            <div>Confirm Password is required</div>
            } @if (f['confirmPassword'].errors['matching']) {
            <div>Confirm Password does not match</div>
            }
          </div>
          }
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center w-100 gap-3">
          <a (click)="onPasswordReset()" class="customPreActivatedButtons text-nowrap">Submit</a>
        </div>
      </div>
    </div>
  </form>

</div>